
    <div  style="padding-bottom: 71px">
      <nav class="navbar fixed-top navbar-light bg-light" style="background-color: #f57a6d!important;color: black;    opacity: 0.75;">
        <a class="navbar-brand" href="#"></a>
        <span class="navbar-text">
   <nav class="fill">
              <ul>
                <li><a href="#"> <i class="fa fa-user"></i> About</a></li>
                <li><a href="#"><i class="fa fa-slack"></i> My Work</a></li>
                <li><a href="#"> <i class="fa fa-shopping-bag"></i> Skills</a></li>
                <li><a href="#"> <i class="fa fa-weixin"></i> Blog</a></li>
                <li><a href="#"> <i class="fa fa-user-secret"></i> Hire Me</a></li>
              </ul>
            </nav>
    </span>
      </nav>
    </div>

